var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1797 13.5854L13.6484 13.056L12.5896 14.1185L13.1208 14.6479L14.1797 13.5854ZM16.5046 18.0201C16.798 18.3125 17.2729 18.3117 17.5653 18.0183C17.8577 17.7249 17.8569 17.25 17.5635 16.9576L16.5046 18.0201ZM14.7151 9.71507C14.7203 12.7373 12.2745 15.1915 9.2523 15.1967L9.25488 16.6967C13.1055 16.6901 16.2217 13.5631 16.2151 9.7125L14.7151 9.71507ZM9.2523 15.1967C6.23008 15.2019 3.77588 12.7561 3.77069 9.73386L2.2707 9.73644C2.27731 13.5871 5.40423 16.7033 9.25488 16.6967L9.2523 15.1967ZM3.77069 9.73386C3.7655 6.71164 6.21129 4.25744 9.23351 4.25225L9.23093 2.75226C5.38029 2.75887 2.26408 5.88579 2.2707 9.73644L3.77069 9.73386ZM9.23351 4.25225C12.2557 4.24706 14.7099 6.69285 14.7151 9.71507L16.2151 9.7125C16.2085 5.86185 13.0816 2.74564 9.23093 2.75226L9.23351 4.25225ZM13.1208 14.6479L16.5046 18.0201L17.5635 16.9576L14.1797 13.5854L13.1208 14.6479Z",
    fill: "#6D7F8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.1d383b82f83f3929247cc1821fc84448.svg";
export { ForwardRef as ReactComponent };